/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type UserAvatar_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type UserWidget_user$ref: FragmentReference;
declare export opaque type UserWidget_user$fragmentType: UserWidget_user$ref;
export type UserWidget_user = {|
  +id: string,
  +firstName: string,
  +lastName: string,
  +$fragmentRefs: UserAvatar_user$ref,
  +$refType: UserWidget_user$ref,
|};
export type UserWidget_user$data = UserWidget_user;
export type UserWidget_user$key = {
  +$data?: UserWidget_user$data,
  +$fragmentRefs: UserWidget_user$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "UserWidget_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "firstName",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "lastName",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "UserAvatar_user",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '1833d9e69be43f01e4638208403026ee';
module.exports = node;
